<template>
  <div class="latest_new">
    <div class="container">
      <div class="sharing_title">
        <img src="../../img/latest_news_icon.svg" alt="最新消息" />
        <h3 :style="{ fontSize: fontSize.h3 + 'em' }">最新消息</h3>
      </div>
      <div class="web_pic_wrap">
        <div class="web_pic_group">
          <template
            class="web_pic_item"
            v-for="(item, i) in news.items"
            :key="i"
          >
            <div class="web_pic_item" href="#" alt="國際趨勢" v-if="i < 3">
              <router-link
                :to="`/news/news_page/${item.pageId}`"
                style="display: block"
                title="國際趨勢文章"
              >
                <p :style="{ fontSize: fontSize.p + 'em' }" class="sec_title">
                  {{ item.type }}
                </p>
                <div v-if="item.video" class="video">
                  <div class="iframe">
                    <div v-html="item.video" />
                  </div>
                </div>
                <div v-else class="pic">
                  <img :src="item.image" alt="國際趨勢圖片" />
                </div>
                <p
                  :style="{ fontSize: fontSize.p + 'em' }"
                  class="text_content"
                >
                  {{ item.title }}
                </p>
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <Carousel :data="news.items" justify="News_page" :rwd="true" />
</template>

<script setup>
import { inject, reactive } from "vue";
import { toArticleFormat } from "@/util/article";
import { apiNews } from "@/api/api.js";
import Carousel from "../Carousel.vue";

let fontSize = inject("fontSize");
const news = reactive({
  items: [],
});

const fetchNews = async () => {
  const {
    data: { newsDatas },
  } = await apiNews({
    keyword: "",
    page: 1,
  });

  const newsItems = newsDatas.map((d) => toArticleFormat(d));
  news.items = newsItems;
};
fetchNews();
</script>

<style scoped lang="scss">
.latest_new {
  padding-top: 40px;
}
.container {
  .sharing_title {
    @include flex_center();
    img {
      width: 7%;
    }
  }
}

.web_pic_wrap {
  @include md {
    display: none;
  }
  .web_pic_group {
    @include flex_between();
    align-items: flex-start;
    .web_pic_item {
      position: relative;
      width: $width / 3;
      margin: 0 5px;
      .pic {
        width: 100%;
        aspect-ratio: 16 / 9;
        overflow: hidden;
        border-radius: 10px;
        z-index: -1;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: 0.3s ease-in-out;

        &:hover {
          transform: scale(1.1);
        }
      }
      p {
        z-index: 1;
        margin-top: 5px;
        &.sec_title {
          position: absolute;
          top: 3%;
          right: 4%;
          color: #fff;
          padding: 5px 10px;
          background-color: $black_color;
        }
        @include black_color();
        text-align: left;
      }
    }
  }
}

.video {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .iframe {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    :deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
